export default "__VITE_ASSET__B1sG3ORK__"